<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>افزودن توکن</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.token.val" :description="form.token.inv" disabled label="توکن" />
                                    <CRow>
                                        <CCol col="6">
                                            <CButton block color="info" @click="form.token.val=$uuid.v4()">تولید توکن</CButton>
                                        </CCol>
                                        <CCol col="6">
                                            <CButton block color="info" v-clipboard="() => this.form.token.val">کپی توکن</CButton>
                                        </CCol>
                                    </CRow>
                                </CCol>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.limit.val" :description="form.limit.inv" dir="ltr" label="محدودیت" />
                                    <small>مقدار نامحدود برابر 1- است.</small>
                                </CCol>
                                <CCol sm="3">
                                    <div v-if="$store.state.perms.can_disable_ip_check_for_token">
                                        <CInput v-model="form.ip.val" :description="form.ip.inv" dir="ltr" label="IP" />
                                        <small>برای غیرفعال کردن IP مقدار 0.0.0.0 را وارد کنید.</small>
                                    </div>
                                    <div v-else>
                                        <CInput v-model="form.token.val" :description="form.token.inv" dir="ltr" label="IP" />
                                    </div>
                                </CCol>
                            </CRow>
                            <br>
                            <CRow>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_active.val"
                                        :description="form.is_active.inv"
                                        label="وضعیت"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.is_active.val=$event.target.value"
                                    />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> افزودن</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
				user_id: {val: '', inv: '', v: { req: true, max: 8 }},
                token: {val: '', inv: '', v: { req: true, max: 128 }},
                limit: {val: '', inv: '', v: { req: true, max: 64 }},
                ip: {val: '', inv: '', v: { req: true, max: 16, spec: 'ip' }},
                is_active: {val: '', inv: '', v: { req: true, max: 8 }},
			},
            disable: false,
            users: [],
        }
    },
    watch: {
        limit: {
            handler(){
                this.form.limit.val = String(this.form.limit.val).replace(/,/g, '');
                this.form.limit.val = String(this.form.limit.val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        },
    },
    mounted() {
        this.get_users();
	},
    methods: {
        get_users(){
            this.axios.get('users/?type=add_token')
            .then(res => {
                res.data.map(val => {
                    this.users.push({value: val.id, text: `${val.id} - ${val.name}`})
                });
            })
        },
        submit(){
            if(this.disable == false){
                const data = new FormData();
                for (const key in this.form){
                    if(key == 'limit'){
                        data.set(key, String(this.form[key].val).replace(/,/g, ''));
                    } else {
                        data.set(key, this.form[key].val);
                    }
                }
                this.axios.post('user_tokens/', data)
                    .then(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'افزودن با موفقیت انجام شد.'
                        });
                        for (const key in this.form){
                            this.form[key].val = '';
                        }
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            }
        }
    },
	beforeCreate(){
        if(this.$store.state.perms.can_add_token == false
            && this.$store.state.perms.can_add_token_for_all_users == false
            && this.$store.state.perms.can_add_token_for_same_group_users == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
